import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { CargoService } from 'src/app/services/cargo.service';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { Utils } from 'src/app/utils/utils';
import { Aprovacao } from 'src/app/models/aprovacao.model';
import { StatusAnalise } from 'src/app/models/enums/status-candidatura-enum';

@Component({
  selector: 'app-candidaturas-indeferidas',
  templateUrl: './candidaturas-indeferidas.component.html',
  styleUrls: ['./candidaturas-indeferidas.component.css']
})
export class CandidaturasIndeferidasComponent implements OnInit {

  cols: any[];
  idEleicao: any;
  idAprovador: any;
  idCargo: any;
  preCandidatos: any;
  candidatura:any;
  token: string;
  displayModalDeferir: boolean = false;
  displayModalIndeferir: boolean = false;
  displayModalAlterar: boolean = false;
  showJustificativa: boolean = false;
  observacao: string;
  justificativaIndeferimento: string;
  preCandidato: any;
  aprovacao: Aprovacao;

  constructor(
    protected router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private preCandidatoService: PreCandidatosService,
    protected messageService: MessageService,
    public utils: Utils
    ) {
      this.idEleicao = +this.route.snapshot.params.idEleicao;
      this.idAprovador = +this.route.snapshot.params.idAprovador;
      this.idCargo = +this.route.snapshot.params.idCargo;
      this.cols = [
        { field: 'nome', header: 'Nome' },
      ];
    }

  ngOnInit() {
    this.token = sessionStorage.getItem('token');
    this.idCargo = sessionStorage.getItem('idCargo');
    this.idAprovador = sessionStorage.getItem('idAprovador');
    document.getElementById("nav-indeferida-tab").onclick = () => this.carregarPreCandidatos(this.idCargo, this.token);
  }

  carregarPreCandidatos(idEleicao: any, token: string) {
    this.preCandidatoService.getPreCandidatoAprovacaoPorIdCargo(idEleicao, token).then(data => {
      this.preCandidatos = data;
      this.preCandidatos = this.preCandidatos.filter(candidato => candidato.statusAnalise === "INDEFERIDA");
      this.spinner.hide();
    },
      error => {
        this.spinner.hide();
        console.error('Erro ao recuperar cargos:', error);
      }
    );
  }

  showModalAlterarLocal(){
    this.displayModalAlterar = true;
  }

  showModalIndeferirLocal() {
    this.showJustificativa = true;
    this.observacao = '';
    this.displayModalIndeferir = true;
    this.justificativaIndeferimento = '';
  }

  showModalDeferirLocal() {
    this.displayModalDeferir = true;
    this.observacao = '';
  }

  hideModalAlterarLocal(){
    this.displayModalAlterar = false;
  }

  hideModalIndeferirLocal() {
    this.displayModalIndeferir = false;
    this.displayModalAlterar = false;
    this.showJustificativa = false;
  }

  hideModalDeferirLocal() {
    this.displayModalDeferir = false;
    this.displayModalAlterar = false;
  }

  async alterarDeferir(observacao: any, idPreCandidato: any) {
    await this.buscarPreCandidato(idPreCandidato, this.token);

    if (this.preCandidato) {
      this.aprovacao = new Aprovacao();
      this.aprovacao.preCandidatoId = this.preCandidato.id;
      this.aprovacao.observacao = observacao;
      this.aprovacao.statusAnalise = StatusAnalise.DEFERIDA;
      this.aprovacao.aprovadorId = this.idAprovador;
      this.aprovacao.justificativaIndeferimento = "";
      this.spinner.show();

      try {
        await this.preCandidatoService.alterarDeferirPreCandidato(this.aprovacao,  this.preCandidato.id, this.token);
        this.spinner.hide();
        this.carregarPreCandidatos(this.idCargo, this.token);
        this.hideModalDeferirLocal();
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Pre Candidato deferido com sucesso!' });
      } catch (error) {
        this.spinner.hide();
        console.error('Erro ao deferir PreCandidato:', error);
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Ocorreu um erro ao deferir o PreCandidato' });
      }
    } else {
      this.spinner.hide();
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Ocorreu um erro ao deferir o PreCandidato' });
    }
  }

  async alterarIndeferir(observacao: any, justificativaIndeferimento: any, idPreCandidato: any) {
    await this.buscarPreCandidato(idPreCandidato, this.token);

    if (this.preCandidato) {
      this.aprovacao = new Aprovacao();
      this.aprovacao.preCandidatoId = this.preCandidato.id;
      this.aprovacao.observacao = observacao;
      this.aprovacao.statusAnalise = StatusAnalise.INDEFERIDA;
      this.aprovacao.aprovadorId = this.idAprovador;
      this.aprovacao.justificativaIndeferimento = justificativaIndeferimento;
      this.spinner.show();

      if(this.aprovacao.justificativaIndeferimento != null && this.aprovacao.justificativaIndeferimento != undefined
        && this.aprovacao.justificativaIndeferimento != ""){
        try {
          await this.preCandidatoService.alterarIndeferirPreCandidato(this.aprovacao, this.preCandidato.id, this.token);
          this.spinner.hide();
          this.carregarPreCandidatos(this.idCargo, this.token);
          this.hideModalIndeferirLocal();
          this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Pre Candidato indeferido com sucesso!' });
        } catch (error) {
          this.spinner.hide();
          console.error('Erro ao indeferir PreCandidato:', error);
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Ocorreu um erro ao indeferir o PreCandidato' });
        }
      }
      else{
        this.spinner.hide();
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'A justificativa é obrigatória para indeferir o PreCandidato' });
      }
    } else {
      this.spinner.hide();
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Ocorreu um erro ao indeferir o PreCandidato' });
    }
  }

  async buscarPreCandidato(idPreCandidato: any, token: string) {
    console.log('Antes de buscar pre candidato');
    try {
      const data = await this.preCandidatoService.getPreCandidadosById(idPreCandidato, token);
      console.log('buscar pre candidato com sucesso', data);
      this.preCandidato = data;
    } catch (error) {
      console.error('Erro ao buscar pre candidato', error);
      throw error;
    }
  }
}


